import { render, staticRenderFns } from "./LeadsPage.vue?vue&type=template&id=6bfc108f&scoped=true&"
import script from "./LeadsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsPage.vue?vue&type=style&index=0&id=6bfc108f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc108f",
  null
  
)

export default component.exports